import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

interface ContactCircleProps {
  color: string;
}

export const ContactCircle = styled.div<ContactCircleProps>`
  background-color: ${(props) => props.color};
  color: #fff;
  font-weight: bold;
  width: 26px;
  height: 26px;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
`;
